import { createCn } from 'cn/config';

export const cn = createCn({
  extend: {
    theme: {
      color: [
        'green-25',
        'green-50',
        'green-100',
        'green-200',
        'green-300',
        'green-400',
        'green-500',
        'green-600',
        'green-700',
        'green-800',
        'green-900',
        'green-950',
        'green-975',

        'purple-25',
        'purple-50',
        'purple-100',
        'purple-200',
        'purple-300',
        'purple-400',
        'purple-500',
        'purple-600',
        'purple-700',
        'purple-800',
        'purple-900',
        'purple-950',
        'purple-975',

        'red-25',
        'red-50',
        'red-100',
        'red-200',
        'red-300',
        'red-400',
        'red-500',
        'red-600',
        'red-700',
        'red-800',
        'red-900',
        'red-950',
        'red-975',

        'amber-25',
        'amber-50',
        'amber-100',
        'amber-200',
        'amber-300',
        'amber-400',
        'amber-500',
        'amber-600',
        'amber-700',
        'amber-800',
        'amber-900',
        'amber-950',
        'amber-975',

        'blue-25',
        'blue-50',
        'blue-100',
        'blue-200',
        'blue-300',
        'blue-400',
        'blue-500',
        'blue-600',
        'blue-700',
        'blue-800',
        'blue-900',
        'blue-950',
        'blue-975',

        'neutral-25',
        'neutral-30',
        'neutral-50',
        'neutral-100',
        'neutral-200',
        'neutral-300',
        'neutral-400',
        'neutral-500',
        'neutral-600',
        'neutral-700',
        'neutral-800',
        'neutral-900',
        'neutral-950',
        'neutral-975',

        'green-highlight',

        'white',
        'black',

        'vauraus-dark-purple',
        'vauraus-light-purple',
        'vauraus-purple-highlight',

        'background-default',
        'background-subtle',
        'background-overlay',

        'surface-default',
        'surface-subtle',
        'surface-disabled',
        'surface-action-primary',
        'surface-action-secondary',
        'surface-action-tertiary',
        'surface-icon-highlight',
        'surface-success',
        'surface-error',
        'surface-warning',
        'surface-info',
        'surface-promo',
        'surface-promo-subtle',

        'text-default',
        'text-subtle',
        'text-highlight',
        'text-inverse',
        'text-success',
        'text-disabled',
        'text-promo',
        'text-brand',
        'text-error',
        'text-warning',

        'icon-default',
        'icon-subtle',
        'icon-inverse',
        'icon-highlight',
        'icon-success',
        'icon-error',
        'icon-warning',
        'icon-info',
        'icon-disabled',
        'icon-brand',

        'border-default',
        'border-highlight',
        'border-success',
        'border-error',
        'border-warning',
        'border-disabled',
        'border-dark',
        'border-brand',

        'divider-default',
      ],
      text: [
        'hero',
        'display',
        'title',
        'heading',
        'section-brand',
        'section-util',
        'body-semibold',
        'body-regular',
        'body-small-semibold',
        'body-small-regular',
        'caption-semibold',
        'caption-regular',
      ],
      breakpoint: ['lg'],
    },
  },
});
